import Image from "next/image";
import { THEME } from "@/enums/profile";
import { useUserProfile } from "@/hooks/useUserProfile";

export default function GailIcon({
  className,
  height = 16,
  width = 16,
}: {
  className?: string;
  height?: number;
  width?: number;
}) {
  const { userProfile } = useUserProfile();

  return (
    <Image
      src={
        userProfile.theme === THEME.DARK
          ? "/icons/gail2-icon-white.svg"
          : "/icons/gail2-icon-black.svg"
      }
      alt="Gail"
      width={width}
      height={height}
      className={className}
    />
  );
}
